import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TableComponent } from '@ui/aos-lib';

import { ListingTableComponent } from './listing-table.component';
import { SidePanelComponent } from '../../../layout/components/side-panel/side-panel.component';

@Component({
  selector: 'aos-alarms-listing-table',
  imports: [AsyncPipe, TableComponent, forwardRef(() => SidePanelComponent)],
  templateUrl: './listing-table.component.html',
  styleUrl: './listing-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlarmsListingTableComponent extends ListingTableComponent {}
